import { posthog } from 'posthog-js'

export const REDIRECT_AFTER_AUTH_FLAG = 'calendar-as-first-view'

export function isRedirectAfterAuthTest() {
  return posthog.getFeatureFlag(REDIRECT_AFTER_AUTH_FLAG) === 'test'
}
